import { CommonModule } from '@angular/common';
import { Component, computed, effect, EffectRef, input, output } from '@angular/core';
import { AttachmentModalData } from '../attachment.modal.model';
import { WeissmanModalService } from '../../Compliance/WeissmanModalService';
import { AttachmentModalComponent } from '../Modal/attachmentModal.component';
import { Attachment } from '../attachment.model';
import { FileDropDirective } from '../../UI-Lib/Directives';

@Component({
    selector: 'entity-attachments',
    templateUrl: './entity-attachments.component.html',
    imports: [CommonModule, FileDropDirective],
})
export class EntityAttachmentsComponent {
    constructor(private readonly _modalService: WeissmanModalService) {}

    hasAttachments = input<boolean>();
    buttonClass = input<string>();
    modalData = input<AttachmentModalData>();
    disabled = input<boolean>();
    isNestedModal = input<boolean>();
    forImages = input<boolean>();
    enableFileDrop = input<boolean>(true);
    uploadFile = input<File>();

    hasAttachmentsChange = output<boolean>();
    hasImagesChange = output<boolean>();
    allAttachmentsChange = output<Attachment[]>();
    isCustomOrderingEnabledChange = output<boolean>();
    entityRowVersionChange = output<string>();

    icon = computed(() => {
        if (this.forImages()) {
            return 'fa-file-image-o';
        } else {
            return this.hasAttachments() ? 'fa-files-o' : 'fa-paperclip';
        }
    });

    private _uploadFileEffect: EffectRef = effect(() => {
        const uploadFile = this.uploadFile();
        if (uploadFile) {
            this.modalData().uploadFile = uploadFile;
            this.showAttachmentsDialog();
        }
    });

    async showAttachmentsDialog(): Promise<void> {
        const result = await this._modalService.showAsync(
            AttachmentModalComponent,
            this.modalData(),
            'modal-xl modal-no-max-width',
        );

        if (result?.count >= 0) {
            this.hasAttachmentsChange.emit(result.count > 0);
            this.hasImagesChange.emit(result.hasImages);
            this.allAttachmentsChange.emit(result.allAttachments);
            if (result.isCustomOrderingEnabled !== undefined) {
                this.isCustomOrderingEnabledChange.emit(result.isCustomOrderingEnabled);
            }
            if (result.entityRowVersion !== undefined) {
                this.entityRowVersionChange.emit(result.entityRowVersion);
            }
        }
    }

    onFilesDropped(files: File[]): void {
        if (this.enableFileDrop()) {
            const data = this.modalData();
            data.uploadFile = files[0];
            this.showAttachmentsDialog();
        }
    }
}
